import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';

import Page from '@lwt-helix/page';
import { Button } from '@lwt-helix/buttons';
import { ResetSuccess, ResetGenericFailed } from './SuccessAndFailureCasesPasswordReset';
import Routes from '../../constants/Routes';
import { useServiceApi } from '../../hooks/services';
import { authServiceApiFactory } from '../../auth/authServiceApiFactory';
import { resetPasswordFailed, resetPasswordSuccess, resettingPassword } from '../../actions/AuthActions';

const ResetPasswordPage = () => {
    const { id } = useParams();

    const { register, handleSubmit } = useForm();

    const passwordResetSuccessful = useSelector(state => state.authenticationReducer.isPasswordReset);
    const submitError = useSelector(state => state.authenticationReducer.error);

    const authServiceApi = useServiceApi(authServiceApiFactory);

    const dispatch = useDispatch();
    const handlePasswordReset = data => {
        dispatch(resettingPassword());
        const response = authServiceApi.resetPassword(data.emailAddress);
        if (!response.error) {
            dispatch(resetPasswordSuccess());
        } else {
            dispatch(resetPasswordFailed(response.error));
        }
    };

    return (
        <>
            <Page fluid hero dataLwtId={'invitations-landing-page'}>
                <form
                    className={'mx-auto my-6 rounded card-raised p-6 card card-body'}
                    style={{ minWidth: '50vw', width: '300px' }}
                    onSubmit={handleSubmit(handlePasswordReset)}
                >
                    <img className="mx-auto mb-3" src="https://assets.lwolf.com/img/lw-logo-dark.svg" alt="Lone Wolf"
                         height="90" />
                    <h3 className="w-100 text-center">Reset Your Lone Wolf Account Password</h3>
                    <hr className="my-4 border-top" />
                    {passwordResetSuccessful
                        ? <ResetSuccess />
                        : <>
                            <label htmlFor="emailAddress" style={{ margin: '0 auto' }}>Existing LWA Email
                                Address</label>
                            <input id="emailAddress" name="emailAddress" type="emailAddress"
                                   className="form-control-md form-control"
                                   {...register('emailAddress', { required: true, pattern: /^\S+@\S+$/i })}
                            />

                            <Button
                                color="primary"
                                onClick={handleSubmit(handlePasswordReset)}
                                style={{ width: '100%' }}
                                dataLwtId={'link-account-button'}
                            >
                                RESET PASSWORD
                            </Button>
                        </>
                    }
                    <div style={{ margin: '0 auto' }}>
                        <a href={Routes.LINK_ACCOUNT.replace(':id', id)}>Click here to retry linking your account.</a>
                    </div>
                    {submitError == null ? null : <ResetGenericFailed />}
                </form>
            </Page>
        </>
    )
};

export default ResetPasswordPage;